import React from 'react';
import { motion } from 'framer-motion';
import { FiAward, FiInfo, FiMapPin, FiStar } from 'react-icons/fi';

export default function GiantMonarch({ data, color }) {
    // 🛡️ BLINDAGEM DE DADOS (API Real + Mock)
    const title = data?.titulo || data?.title || 'Propriedade Real';
    const price = data?.preco || data?.price;
    const location = data?.bairro || data?.location || 'Distrito Imperial';
    const mainImage = data?.imagensDestaque?.[0] || data?.image || 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750';

    const formattedPrice = typeof price === 'number' 
        ? price.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        : price || 'Valor sob Consulta';

    return (
        <motion.div 
            initial={{ opacity: 0, scale: 1.05 }}
            animate={{ opacity: 1, scale: 1 }}
            className="w-full h-[700px] relative rounded-[3rem] overflow-hidden border-[12px] shadow-[0_35px_60px_-15px_rgba(0,0,0,0.5)] group"
            style={{ borderColor: 'var(--bg-main)' }}
        >
            {/* 🖼️ BACKGROUND: PINTURA EM VIVO */}
            <img 
                src={mainImage} 
                className="w-full h-full object-cover transition-transform duration-[4s] group-hover:scale-110" 
                alt={title} 
            />
            
            {/* 🎭 VÉU DE NOBREZA (OVERLAY) */}
            <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-transparent to-black/80" />

            {/* 🏰 MOLDURA INTERNA (PASSEPARTOUT) */}
            <div className="absolute inset-8 border border-white/20 pointer-events-none" />

            {/* 🎖️ SELO DE AUTENTICIDADE */}
            <div className="absolute top-16 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2">
                <FiAward className="text-white opacity-80" size={24} style={{ color: color }} />
                <span className="text-[8px] font-black uppercase tracking-[0.8em] text-white/60">Heritage Collection</span>
            </div>

            {/* 📜 O BRASÃO (CONTEÚDO CENTRAL) */}
            <div className="absolute inset-0 flex items-center justify-center">
                <motion.div 
                    initial={{ y: 20, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ delay: 0.3 }}
                    className="p-16 backdrop-blur-md bg-black/20 border border-white/10 text-center max-w-3xl mx-auto shadow-2xl"
                >
                    <div className="flex justify-center gap-2 mb-6">
                        {[...Array(5)].map((_, i) => (
                            <FiStar key={i} size={10} fill={color} stroke={color} className="opacity-50" />
                        ))}
                    </div>
                    
                    <h2 className="text-white text-8xl font-serif italic mb-6 tracking-tight drop-shadow-2xl">
                        {title}
                    </h2>
                    
                    <div className="h-px w-48 bg-white/40 mx-auto mb-8 relative">
                        <div className="absolute inset-0 w-1/3 bg-white mx-auto" style={{ backgroundColor: color }} />
                    </div>
                    
                    <p className="text-white font-black tracking-[0.6em] uppercase text-[10px] mb-4">
                        Exclusividade Certificada MOS Gold
                    </p>
                    
                    <div className="flex items-center justify-center gap-3 text-white/60 text-[11px] font-medium uppercase tracking-widest">
                        <FiMapPin size={14} style={{ color: color }} /> {location}
                    </div>
                </motion.div>
            </div>

            {/* 💰 VALOR E AÇÃO (FOOTER) */}
            <div className="absolute bottom-16 left-0 right-0 px-20 flex justify-between items-end">
                <div className="text-left">
                    <span className="text-[9px] font-bold uppercase tracking-widest text-white/40 block mb-1">Investimento Coletivo</span>
                    <div className="text-5xl font-black text-white italic tracking-tighter" style={{ color: color }}>
                        {formattedPrice}
                    </div>
                </div>

                <button 
                    className="px-12 py-5 bg-white text-black font-black uppercase text-[10px] tracking-[0.4em] hover:bg-black hover:text-white transition-all duration-500 shadow-2xl flex items-center gap-4"
                >
                    Inspecionar Legado <FiInfo size={16} />
                </button>
            </div>

            {/* 🕰️ SERIAL TÁTICO */}
            <div className="absolute bottom-6 left-1/2 -translate-x-1/2 opacity-30">
                <span className="text-[7px] font-black uppercase tracking-[1.2em] text-white">Monarch Protocol // Royal Edition</span>
            </div>
        </motion.div>
    );
}